import React, { useState } from "react";
import { ContainerForGallery, TitleText } from "./styled";
import Image from "next/image";
import Lightbox from "react-image-lightbox";
// import 'react-image-lightbox/style.css';

function Gallery({ renderGallery, allPictures, hideTitle }) {
  let pictures = allPictures.allPhotos;

  const [isOpen, setisOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  return (
    <>
      {!hideTitle && <TitleText>Gallery </TitleText>}
      <ContainerForGallery>
        {pictures.map((photo, index) => {
          if (index < 8) {
            return (
              <div
                key={photo.src}
                className={"img"}
                tabIndex="0"
                onClick={() => {
                  try {
                    setPhotoIndex(index);
                    setisOpen(true);
                  } catch (e) {
                    alert(e);
                  }
                }}
              >
                <Image
                  src={photo.src}
                  alt={
                    photo.alt || `example of ${allPictures.categoryName} work`
                  }
                  className={"custom-image"}
                  quality={40}
                  layout={"fill"}
                  loading="lazy"
                  objectFit="cover"
                />
              </div>
            );
          }
          return null;
        })}

        {renderGallery &&
          pictures.map((photo, index) => {
            if (index >= 8) {
              return (
                <div
                  key={photo.src}
                  className={"img"}
                  onClick={() => {
                    try {
                      setPhotoIndex(index);
                      setisOpen(true);
                    } catch (e) {
                      console.error(e);
                    }
                  }}
                >
                  <Image
                    src={photo.src}
                    alt={
                      photo.alt || `example of ${allPictures.categoryName} work`
                    }
                    className={"custom-image"}
                    quality={40}
                    layout={"fill"}
                    loading="lazy"
                    objectFit="cover"
                  // width={100}
                  // height={70}
                  />
                </div>
              );
            }
            return null;
          })}
      </ContainerForGallery>

      {isOpen && (
        <Lightbox
          mainSrc={pictures[photoIndex].src}
          nextSrc={pictures[(photoIndex + 1) % pictures.length].src}
          prevSrc={
            pictures[(photoIndex + pictures.length - 1) % pictures.length].src
          }
          onCloseRequest={() => {
            setisOpen(false);
            setPhotoIndex(0);
          }}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + pictures.length - 1) % pictures.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % pictures.length)
          }
          clickOutsideToClose={false}
        />
      )}
    </>
  );
}

export default Gallery;
